export default "__VITE_ASSET__tmjQTJOo__"